import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../api';
import { useAuth } from '../auth';

/** Eigenes Konto einsehen und endgültig löschen (Art. 17 DSGVO). */
export function AccountPage() {
  const { t } = useTranslation();
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [confirming, setConfirming] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!user) return null;

  async function remove(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.auth.deleteAccount(password);
      setUser(null);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? t([`errors.${err.code}`, 'errors.generic']) : t('errors.generic'));
      setBusy(false);
    }
  }

  return (
    <div className="container page stack">
      <div>
        <div className="eyebrow">{t('account.title')}</div>
        <h1>{user.displayName}</h1>
        <p className="muted" style={{ marginTop: -4 }}>{user.email}</p>
      </div>

      <div className="card stack">
        <div className="field">
          <label>{t('auth.displayName')}</label>
          <div className="mono">{user.displayName}</div>
        </div>
        <div className="field">
          <label>{t('auth.email')}</label>
          <div className="mono">{user.email}</div>
        </div>
        {user.isAdmin && <div className="notice">{t('account.isAdmin')}</div>}
      </div>

      <div className="card stack">
        <div className="eyebrow">{t('settings.dangerZone')}</div>
        <div>
          <strong>{t('account.delete')}</strong>
          <p className="muted" style={{ margin: '2px 0 0', fontSize: '0.85rem' }}>
            {t('account.deleteHint')}
          </p>
        </div>

        {confirming ? (
          <form className="stack" onSubmit={remove}>
            <div className="field">
              <label htmlFor="delpw">{t('account.confirmPassword')}</label>
              <input
                id="delpw"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="account-delete-password"
              />
            </div>
            {error && <div className="notice notice-error">{error}</div>}
            <div className="row" style={{ gap: 10 }}>
              <button
                className="btn btn-danger"
                type="submit"
                disabled={busy || !password}
                data-testid="account-delete-confirm"
              >
                {busy ? t('common.loading') : t('account.deleteConfirm')}
              </button>
              <button
                className="btn btn-ghost"
                type="button"
                onClick={() => {
                  setConfirming(false);
                  setPassword('');
                  setError(null);
                }}
              >
                {t('common.cancel')}
              </button>
            </div>
          </form>
        ) : (
          <div className="row">
            <button
              className="btn"
              type="button"
              onClick={() => setConfirming(true)}
              data-testid="account-delete"
            >
              {t('account.delete')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
